import { useState, useEffect, useRef } from "react";
import Carousel from "react-spring-3d-carousel";
import { PopupDialog } from "../components/popupDialog";
import { config } from "react-spring";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

export const MediaSlider = ({
  mediaList = [],
  isAutoLoop = true,
  isVideo = false,
}) => {
  const autoLoopSeconds = 3000;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [open, setOpen] = useState(false);
  const [currentMedia, setCurrentMedia] = useState("");
  const autoLoopRef = useRef();
  const slides = mediaList.map((media, index) => ({
    key: index,
    content: isVideo ? (
      <video
        src={media}
        controls
        preload="metadata"
        className="slider-media"
        controlsList="nodownload"
      />
    ) : (
      <img
        src={media}
        alt={`media ${index}`}
        className="slider-media"
        onClick={() => handleMediaClick(media)}
      />
    ),
  }));
  const handleMediaClick = (media) => {
    setCurrentMedia(media);
    setOpen(true);
    setIsPaused(true);
    stopAutoLoop();
  };
  const handleClose = () => {
    setOpen(false);
    setIsPaused(false);
    startAutoLoop();
  };
  const handleNext = () => {
    setIsPaused(true);
    setCurrentIndex((prevIndex) => (prevIndex + 1) % mediaList.length);
    debounceStartAutoLoop();
  };
  const handlePrev = () => {
    setIsPaused(true);
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + mediaList.length) % mediaList.length
    );
    debounceStartAutoLoop();
  };
  const startAutoLoop = () => {
    if (isAutoLoop && !isPaused) {
      autoLoopRef.current = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % mediaList.length);
      }, autoLoopSeconds);
    }
  };
  const stopAutoLoop = () => {
    if (autoLoopRef.current) {
      clearInterval(autoLoopRef.current);
    }
  };
  const debounceStartAutoLoop = () => {
    stopAutoLoop();
    setTimeout(() => {
      setIsPaused(false);
      startAutoLoop();
    }, 1000);
  };
  useEffect(() => {
    startAutoLoop();
    return () => stopAutoLoop();
  }, [isAutoLoop, mediaList.length]);

  return (
    mediaList.length > 0 && (
      <div className="slider-container">
        <Carousel
          slides={slides}
          goToSlide={currentIndex}
          offsetRadius={2}
          showNavigation={false}
          animationConfig={{ ...config.gentle, duration: 700 }}
        />
        {mediaList.length > 1 && (
          <div>
            <div className="navigation-buttons navigation-prev-buttons">
              <FaChevronLeft className="slider-button" onClick={handlePrev} />
            </div>
            <div className="navigation-buttons navigation-next-buttons">
              <FaChevronRight className="slider-button" onClick={handleNext} />
            </div>
          </div>
        )}
        <PopupDialog
          name="mediaModal"
          open={open}
          onClose={handleClose}
          content={
            <div className="image-container">
              <img
                src={currentMedia}
                alt="Enlarged"
                className="image-container-img"
              />
            </div>
          }
        />
        {!isVideo && mediaList.length > 1 && (
          <div className="indicator-dots">
            {mediaList.map((_, index) => (
              <span
                key={index}
                className={`dot ${currentIndex === index ? "active" : ""}`}
                onClick={() => setCurrentIndex(index)}
              />
            ))}
          </div>
        )}
      </div>
    )
  );
};
